import { TuiDay } from '@taiga-ui/cdk';
import { DateString } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tuiDay',
  standalone: true,
})
export class TuiDayPipe implements PipeTransform {
  public transform(value: Date | DateString | null | undefined): TuiDay | any {
    if (!value) {
      return null;
    }

    return TuiDay.fromLocalNativeDate(new Date(value));
  }
}
